module.exports = __webpack_public_path__ + "static/img/WechatIMG598.2ee21e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WechatIMG598.png
// module id = wuFb
// module chunks = 12